module.exports = __webpack_public_path__ + "img/boitumelo-baleni.589ec33f.png";